if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// ADD DATA-ATTR TO BTNs
const addBTNsSpan = () => {
	document.querySelectorAll('.btn-secondary').forEach((btn) => {
		btn.innerHTML = `<span>${btn.textContent}</span>`;
	});
};

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    
    $('.big-slider-js').slick({
        accessibility: false
    });
    
    // Arrows Funcionality
    $(".big-slider__arrows .slick-prev").click(function(){
        $(".big-slider-js").slick("slickPrev");
    });

    $(".big-slider__arrows .slick-next").click(function(){
        $(".big-slider-js").slick("slickNext");
    });

    // Dots Funcionality
    $('.js-slick-dots').each((i, dots) => {
        $('button', dots).click((e) => {
            let slideTo = $(e.currentTarget).data('goto');
            $(dots).closest('.big-slider-js').slick('slickGoTo', slideTo);
        });
    });


    $('.gallery-slider').slick({
        accessibility: false,
        arrows: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        appendArrows:'.gallery-block__arrows',
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
                variableWidth: false,
                centerMode: false,
              }
            }
          ]

    });

    // ADD DATA-ATTR TO BTNs
	addBTNsSpan();

})();